import React from "react";
import Page, { mmToPixel } from "../models/Page";
import { PagePrintInfo } from "../models/PagePrintInfo";
import { RDiv } from "./renderPrimitives/RDiv";
import { RenderTarget, useRenderTarget } from "./renderPrimitives/renderTarget";

export default function PageFrame(props: { page: Page; print?: PagePrintInfo; children: any }) {
  const { page, children, print } = props;

  const target = useRenderTarget();

  var printableArea = page.printableArea;

  const frameWidth = page.frameWidth;

  let left = frameWidth * 10 * mmToPixel;
  if (target == RenderTarget.pdf) {
    left -= 2;
  }

  let top = left;

  return (
    <RDiv
      id="pageFrame"
      style={{
        position: "relative",
        width: `${printableArea.width}cm`,
        height: `${printableArea.height}cm`,
        outline: "2px solid var(--text-color)",
        background: "var(--colorTransparent)",
        pointerEvents: "none",
      }}
    >
      <RDiv
        style={{
          position: "absolute",
          left: `${left}px`,
          top: `${top}px`,
          width: `${printableArea.width - 2 * frameWidth}cm`,
          height: `${printableArea.height - 2 * frameWidth}cm`,
          outline: "2px solid var(--text-color)",
          background: "var(--colorTransparent)",
          pointerEvents: "none",
        }}
      >
        {children}
      </RDiv>
    </RDiv>
  );
}
